<template>
  <div>
    <h2 class="blind">시상내역</h2>
    <span class="gray-text">이마티콘 시상내역을 확인하실 수 있습니다.</span>
    <ul class="mydetail-button-list">
      <li><button :class="{'focus' : selectPeriod === '1month'}" @click.prevent="selectPeriod = '1month'">1개월</button><h2 class="blind" v-if="selectPeriod === '1month'">선택됨</h2></li>
      <li><button :class="{'focus' : selectPeriod === '3month'}" @click.prevent="selectPeriod = '3month'">3개월</button><h2 class="blind" v-if="selectPeriod === '3month'">선택됨</h2></li>
      <li><button :class="{'focus' : selectPeriod === '6month'}" @click.prevent="selectPeriod = '6month'">6개월</button><h2 class="blind" v-if="selectPeriod === '6month'">선택됨</h2></li>
      <li><button :class="{'focus' : selectPeriod === 'select'}" @click.prevent="selectPeriod = 'select'">기간조회</button><h2 class="blind" v-if="selectPeriod === 'select'">선택됨</h2></li>
    </ul>
    <h2 class="blind">{{selectPeriodText}}</h2>
    <div class="usage-date-box" v-if="selectPeriod==='select'">
      <input type="date" name="firstDate" v-model="startDate" data-placeholder="시작일" @change="validPeriod" required/>
      <input type="date" name="lastDate" v-model="lastDate" data-placeholder="종료일" @change="validPeriod" required/>
      <button type="button" @click.prevent="searchPeriod">검색</button>
    </div>
    <div class="usage-gray-box">
      <div>
        <span>총 선물 금액</span>
        <em>{{giftSum | comma}}</em>
      </div>
    </div>
    <ul class="save-list" v-if="giftListData.length > 0">
      <li class="save-item" v-for="item in giftListData" :key="item.transactionDateTime">
        <div class="save-item-top">
          <div>
            <strong>To.</strong>
            <strong>{{ item.receiver }}</strong>
            <span>({{ item.receiverContact }})</span>
          </div>
          <div v-if="item.giftVoidable">
            <button @click="cancelPurchasePopup(item)">취소</button>
          </div>
        </div>
        <div class="flex" @click="toggleReceiptPopup(item.receiptUrl)">
          <div class="save-item-left">
            <img :src="item.thumbnailImageUrl" :alt="item.thumbnailImageDesc" />
          </div>
          <div class="save-item-right">
            <div class="save-item-birth">
              <span>{{ item.giftMessage }}</span>
            </div>
            <div class="save-item-price">
              <strong>{{(item.voided? "-"+ item.originalAmount :  item.originalAmount) | comma}}</strong>
              <div>
                <span>구매일<em>{{ item.frontDate }}</em></span>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <!-- 조회 결과 x  -->
    <div class="usage-not-result" v-if="giftListData.length === 0">
      <em class="icon-round-tooltip"></em>
      <span>조회 결과가 없습니다.</span>
    </div>
    <alert-popup v-if="alertPopupShow" :message="alertMessage" @confirmPopupClickConfirm="alertPopupShow = false"></alert-popup>
    <receipt-popup v-if="showReceiptPopup" :receiptUrl="receiptUrl" @toggleReceiptPopup="toggleReceiptPopup"></receipt-popup>
    <pagination
        :totalRows="giftListTotalRow"
        :pageModel="pageModel"
        v-on:movePage="movePage"
    />
    <bottom-confirm-popup v-if="showConfirmPopup === true" :message="confirmMessage" :cardInfo="cancelGift" @noEvent="showConfirmPopup = false" @yesEvent="purchaseCancel"></bottom-confirm-popup>
    <bottom-popup v-if="showBottomPopup === true" :message="bottomPopupMessage" @closeEvent="showBottomPopup = false"></bottom-popup>
  </div>
</template>

<script>
import apiList from "@/api/apiList";
import dayjs from "dayjs";
import AlertPopup from "@/views/myemarticon/alertPopup";
import Pagination from "@/components/common/Pagination";
import ConfirmPopup from "@/views/myemarticon/confirmPopup";
import BottomConfirmPopup from "@/views/myemarticon/bottomConfirmPopup";
import BottomPopup from "@/views/myemarticon/bottomPopup.vue";
import ReceiptPopup from "@/views/myemarticon/mydetail/receiptPopup.vue";

export default {
  name: "awardDetailGift",
  components: {BottomPopup, AlertPopup, Pagination,ConfirmPopup, BottomConfirmPopup, ReceiptPopup },
  data() {
    return {
      selectPeriodText: '1개월', //웹접근성
      selectPeriod: '1month',
      startDate: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      lastDate: dayjs().format('YYYY-MM-DD'),
      giftSum: 0,
      // 선물내역 데이터
      giftListData: [
      ],
      pageModel: {
        size: 10,
        pageNo: 1
      },
      giftListTotalRow: 0,
      confirmMessage: '', //컨펌 메시지
      alertMessage: "",
      alertPopupShow: false,
      showConfirmPopup: false,  //선물하기 취소 컨펌팝업
      showBottomPopup: false, //bottomPopup 보여줄지 여부
      bottomPopupMessage: '', //bottomPopup 메시지
      cancelGift: {},
      showReceiptPopup: false,
      receiptUrl: '',
    }
  },
  filters: {
    comma(num) {
      return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  watch: {
    selectPeriod(value) {
      switch (value) {
        case '1month' :
          this.startDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD');
          this.lastDate = dayjs().format('YYYY-MM-DD');
          this.selectPeriodText = '1개월';
          break;
        case '3month' :
          this.startDate = dayjs().subtract(3, 'month').format('YYYY-MM-DD');
          this.lastDate = dayjs().format('YYYY-MM-DD');
          this.selectPeriodText = '3개월';
          break;
        case '6month' :
          this.startDate = dayjs().subtract(6, 'month').format('YYYY-MM-DD');
          this.lastDate = dayjs().format('YYYY-MM-DD');
          this.selectPeriodText = '6개월';
          break;
        case 'select' :
          this.startDate = dayjs().subtract(7, 'day').format('YYYY-MM-DD');
          this.lastDate = dayjs().format('YYYY-MM-DD');
          this.selectPeriodText = '기간조회';
          break;
        default:
          this.startDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD');
          this.lastDate = dayjs().format('YYYY-MM-DD');
          this.selectPeriodText = '1개월';
      }
      this.pageModel.pageNo = 1;
      this.giftListData = [];
      this.getPrepaidCardGiftDetail();
    }
  },
  mounted() {
    this.getPrepaidCardGiftDetail();
  },
  methods: {
    async getPrepaidCardGiftDetail() {
      try{
        const param = {
          startDate: this.startDate,
          endDate: this.lastDate,
          size: this.pageModel.size,
          pageNo: this.pageModel.pageNo
        }

        const response = await apiList.getPrepaidGiftDetail(param);

        this.giftListTotalRow =  response.data.data.giftDetails.totalRows;
        this.giftSum = response.data.data.giftSum;
        this.giftListData = [];
        for(let data of response.data.data.giftDetails.list) {
          data.frontDate = dayjs(data.transactionDateTime).format('YYYY/MM/DD');
          this.giftListData.push(data);
        }

      } catch (error) {
        console.error(error);
      }
    },
    searchPeriod() {
      if(dayjs(this.lastDate).diff(dayjs(this.startDate), 'day') > 365) {
        this.alertPopupShow = true;
        this.alertMessage = '조회기간은 최대 12개월 입니다.';
        return;
      }

      if(!this.validPeriod()) {
        return;
      }
      this.giftListData = [];
      this.pageModel.pageNo = 1;
      this.getPrepaidCardGiftDetail();
    },
    validPeriod() {
      if(this.startDate > this.lastDate) {
        this.alertPopupShow = true;
        this.alertMessage = '종료일이 시작일보다 이전일 수는 없습니다.';
        return false;
      }
      return true;
    },
    movePage(pageNo) {
      this.pageModel.pageNo = pageNo;
      this.getPrepaidCardGiftDetail();
    },
    cancelPurchasePopup(gift) {
      this.confirmMessage = "정말로 선물을 취소하겠습니까?"

      this.cancelGift = {
        prepaidCardNo: gift.prepaidCardNo,
        imageUrl: gift.imageUrl,
        remainCash: gift.originalAmount,
        prepaidCardNickName: gift.receiver,
        issueDate: dayjs(gift.transactionDateTime).format('YYYY-MM-DD')
      }
      this.showConfirmPopup = true
    },
    async purchaseCancel(cardInfo) {  //컨펌팝업에서 예 누르면 이벤트 실행
      this.showConfirmPopup = false


      console.log("cardInfo" + JSON.stringify(cardInfo));


      const params = {
        ctmmnyNo: this.$store.state.partnerId,
        prepaidCardNo: cardInfo.prepaidCardNo,
        mberNo: this.$store.state.mberInfo.mberNo,
        requestId: this.$store.state.mberInfo.mberNo,
        method: "paymentVoid"
      }

      const res = await apiList.putGiftPrepaidPaymentVoid(params)

      if (res.data.code == 'S00000') {
        this.bottomPopupMessage = "선물 취소가 완료 되었습니다"
        this.showBottomPopup = true;
        this.getPrepaidCardGiftDetail();
      } else {
        this.alertMessage = "선물 취소하기에 실패 하였습니다"
        this.alertPopupShow = true;
        this.getPrepaidCardGiftDetail();
      }
    },
    toggleReceiptPopup(receiptUrl) {
      this.showReceiptPopup = !this.showReceiptPopup
      if(this.showReceiptPopup) {
        this.receiptUrl = receiptUrl;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/pages/myemarticon/myDetail.scss';
</style>